import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { ConnectedCustomersStatus } from "@/types/legacyMigration";

export const getConnectedCustomersStatus = async (
  organisationUuid: string,
): Promise<ConnectedCustomersStatus> => {
  const res = await $http.get<ConnectedCustomersStatus>(
    `${getApiClientUrl()}/v1/pt/orgs/${organisationUuid}/customers/connected`,
  );

  return res.data;
};

export default {
  getConnectedCustomersStatus,
};
